export interface ListenerProfile {
  id: number;
  name: string;
  username: string;
  avatarUrl: string;
  bio: string;
  email: string;
  location: string;
  joinDate: string;
  stats: {
    totalListeningHours: number;
    messagesSent: number;
    radiosFavorited: number;
    radiosFollowed: number;
    eventsAttended: number;
    badges: string[];
  };
}

export interface FavoriteRadioEntry {
  id: number;
  stationId: number;
  stationName: string;
  frequency: string;
  category: string;
  logoUrl: string;
  favoritedAt: string;
  isLive: boolean;
}

export interface FollowedRadioEntry {
  id: number;
  stationId: number;
  stationName: string;
  frequency: string;
  category: string;
  logoUrl: string;
  followedAt: string;
  isLive: boolean;
  listeners: number;
}

export interface ListeningHistoryEntry {
  id: number;
  stationId: number;
  stationName: string;
  frequency: string;
  category: string;
  logoUrl: string;
  listenedAt: string;
  durationMinutes: number;
  programName: string;
}

export interface SentMessageEntry {
  id: number;
  stationId: number;
  stationName: string;
  stationLogo: string;
  message: string;
  sentAt: string;
  type: string;
  status: string;
  reply: string | null;
}

export interface SavedEventEntry {
  id: number;
  stationId: number;
  stationName: string;
  eventTitle: string;
  eventDate: string;
  eventTime: string;
  eventType: string;
  imageUrl: string;
  savedAt: string;
  isUpcoming: boolean;
}

export interface NotificationEntry {
  id: number;
  type: 'new_transmission' | 'new_event' | 'contest' | 'radio_message' | 'upcoming_live';
  title: string;
  message: string;
  timestamp: string;
  isRead: boolean;
  isArchived: boolean;
  actionUrl: string;
  stationName: string | null;
}

export interface SavedLiveEntry {
  id: number;
  stationId: number;
  stationName: string;
  stationLogo: string;
  programName: string;
  hostName: string;
  savedAt: string;
  status: 'live' | 'scheduled' | 'finished';
  durationMinutes: number;
  coverUrl: string;
}

export const listenerProfile: ListenerProfile = {
  id: 101,
  name: "Marco Antonio Rivera",
  username: "@marco_oyente",
  avatarUrl: "https://readdy.ai/api/search-image?query=Young%20Hispanic%20male%20portrait%20with%20friendly%20warm%20smile%2C%20casual%20modern%20style%2C%20wearing%20simple%20navy%20t-shirt%2C%20clean%20soft%20background%20with%20warm%20natural%20lighting%2C%20approachable%20authentic%20headshot%20photography%2C%20editorial%20portrait%20style&width=400&height=400&seq=listener-avatar-1&orientation=squarish",
  bio: "Amante de la música regional mexicana, el rock clásico y la buena radio. Oyente fiel desde 2020. Siempre con la radio encendida mientras trabajo.",
  email: "marco.rivera@email.com",
  location: "Houston, Texas",
  joinDate: "2020-03-15",
  stats: {
    totalListeningHours: 2847,
    messagesSent: 342,
    radiosFavorited: 8,
    radiosFollowed: 12,
    eventsAttended: 5,
    badges: ["Oyente Fiel", "Madrugador", "Mega Fan", "Comunicador"],
  },
};

export const favoriteRadios: FavoriteRadioEntry[] = [
  {
    id: 1,
    stationId: 3,
    stationName: "La Mexicana FM",
    frequency: "103.50 RFW",
    category: "Regional Mexicana",
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-3&orientation=squarish",
    favoritedAt: "2025-01-10",
    isLive: true,
  },
  {
    id: 2,
    stationId: 5,
    stationName: "Rock Total Radio",
    frequency: "87.01 RFW",
    category: "Rock",
    logoUrl: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-5&orientation=squarish",
    favoritedAt: "2025-02-20",
    isLive: true,
  },
  {
    id: 3,
    stationId: 7,
    stationName: "Deportes Total Radio",
    frequency: "120.00 RFW",
    category: "Deportes",
    logoUrl: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-7&orientation=squarish",
    favoritedAt: "2025-03-05",
    isLive: true,
  },
  {
    id: 4,
    stationId: 1,
    stationName: "Radio Nueva Actitud",
    frequency: "94.70 RFW",
    category: "Pop",
    logoUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20and%20white%20color%20palette%2C%20simple%20geometric%20shapes%2C%20professional%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20high%20contrast%20vector%20style&width=200&height=200&seq=logo-1&orientation=squarish",
    favoritedAt: "2025-04-12",
    isLive: true,
  },
  {
    id: 5,
    stationId: 2,
    stationName: "Radio Fe y Esperanza",
    frequency: "87.00 RFW",
    category: "Cristiana",
    logoUrl: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem%2C%20spiritual%20community%20radio%2C%20isolated%20on%20transparent%20background%2C%20vector%20style%20flat%20design&width=200&height=200&seq=logo-2&orientation=squarish",
    favoritedAt: "2025-05-08",
    isLive: true,
  },
  {
    id: 6,
    stationId: 11,
    stationName: "Radio Vida Nueva",
    frequency: "180.00 RFW",
    category: "Cristiana",
    logoUrl: "https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20station%20logo%20with%20cross%20and%20sunrise%20symbols%2C%20circular%20design%20soft%20blue%20and%20white%20colors%2C%20peaceful%20spiritual%20broadcast%20emblem%2C%20minimalist%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-11&orientation=squarish",
    favoritedAt: "2025-05-15",
    isLive: true,
  },
  {
    id: 7,
    stationId: 12,
    stationName: "Banda Radio MX",
    frequency: "200.00 RFW",
    category: "Regional Mexicana",
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20and%20green%20colors%2C%20festive%20broadcast%20emblem%2C%20traditional%20Mexican%20vibe%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-12&orientation=squarish",
    favoritedAt: "2025-06-01",
    isLive: true,
  },
  {
    id: 8,
    stationId: 9,
    stationName: "La Kalle 99.9",
    frequency: "99.90 RFW",
    category: "Pop",
    logoUrl: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20purple%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-9&orientation=squarish",
    favoritedAt: "2025-06-04",
    isLive: true,
  },
];

export const followedRadios: FollowedRadioEntry[] = [
  {
    id: 1,
    stationId: 3,
    stationName: "La Mexicana FM",
    frequency: "103.50 RFW",
    category: "Regional Mexicana",
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-3&orientation=squarish",
    followedAt: "2024-11-20",
    isLive: true,
    listeners: 12450,
  },
  {
    id: 2,
    stationId: 5,
    stationName: "Rock Total Radio",
    frequency: "87.01 RFW",
    category: "Rock",
    logoUrl: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-5&orientation=squarish",
    followedAt: "2024-12-05",
    isLive: true,
    listeners: 7234,
  },
  {
    id: 3,
    stationId: 7,
    stationName: "Deportes Total Radio",
    frequency: "120.00 RFW",
    category: "Deportes",
    logoUrl: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-7&orientation=squarish",
    followedAt: "2025-01-15",
    isLive: true,
    listeners: 10890,
  },
  {
    id: 4,
    stationId: 1,
    stationName: "Radio Nueva Actitud",
    frequency: "94.70 RFW",
    category: "Pop",
    logoUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20and%20white%20color%20palette%2C%20simple%20geometric%20shapes%2C%20professional%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20high%20contrast%20vector%20style&width=200&height=200&seq=logo-1&orientation=squarish",
    followedAt: "2025-01-22",
    isLive: true,
    listeners: 2847,
  },
  {
    id: 5,
    stationId: 6,
    stationName: "Radio Comunitaria Unida",
    frequency: "87.02 RFW",
    category: "Comunitaria",
    logoUrl: "https://readdy.ai/api/search-image?query=Community%20radio%20station%20logo%20with%20people%20holding%20hands%20in%20circle%2C%20minimalist%20design%20with%20warm%20earth%20tones%2C%20green%20and%20orange%20colors%2C%20inclusive%20broadcast%20emblem%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-6&orientation=squarish",
    followedAt: "2025-02-10",
    isLive: true,
    listeners: 1567,
  },
  {
    id: 6,
    stationId: 4,
    stationName: "Noticias 24/7 Radio",
    frequency: "107.90 RFW",
    category: "Noticias",
    logoUrl: "https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%20design%20with%20microphone%20and%20globe%20icon%2C%20circular%20minimalist%20emblem%2C%20blue%20and%20white%20professional%20color%20scheme%2C%20broadcast%20journalism%20style%2C%20isolated%20on%20transparent%20background%2C%20clean%20vector%20design&width=200&height=200&seq=logo-4&orientation=squarish",
    followedAt: "2025-02-28",
    isLive: false,
    listeners: 8921,
  },
  {
    id: 7,
    stationId: 2,
    stationName: "Radio Fe y Esperanza",
    frequency: "87.00 RFW",
    category: "Cristiana",
    logoUrl: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem%2C%20spiritual%20community%20radio%2C%20isolated%20on%20transparent%20background%2C%20vector%20style%20flat%20design&width=200&height=200&seq=logo-2&orientation=squarish",
    followedAt: "2025-03-10",
    isLive: true,
    listeners: 5632,
  },
  {
    id: 8,
    stationId: 10,
    stationName: "Radio Voz del Pueblo",
    frequency: "160.00 RFW",
    category: "Comunitaria",
    logoUrl: "https://readdy.ai/api/search-image?query=Local%20community%20radio%20station%20logo%20with%20city%20skyline%20and%20microphone%2C%20circular%20design%20warm%20brown%20and%20cream%20colors%2C%20grassroots%20broadcast%20emblem%2C%20local%20charm%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-10&orientation=squarish",
    followedAt: "2025-04-05",
    isLive: true,
    listeners: 2890,
  },
  {
    id: 9,
    stationId: 12,
    stationName: "Banda Radio MX",
    frequency: "200.00 RFW",
    category: "Regional Mexicana",
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20and%20green%20colors%2C%20festive%20broadcast%20emblem%2C%20traditional%20Mexican%20vibe%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-12&orientation=squarish",
    followedAt: "2025-04-20",
    isLive: true,
    listeners: 9780,
  },
  {
    id: 10,
    stationId: 11,
    stationName: "Radio Vida Nueva",
    frequency: "180.00 RFW",
    category: "Cristiana",
    logoUrl: "https://readdy.ai/api/search-image?query=Christian%20worship%20radio%20station%20logo%20with%20cross%20and%20sunrise%20symbols%2C%20circular%20design%20soft%20blue%20and%20white%20colors%2C%20peaceful%20spiritual%20broadcast%20emblem%2C%20minimalist%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-11&orientation=squarish",
    followedAt: "2025-05-01",
    isLive: true,
    listeners: 4156,
  },
  {
    id: 11,
    stationId: 9,
    stationName: "La Kalle 99.9",
    frequency: "99.90 RFW",
    category: "Pop",
    logoUrl: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20purple%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-9&orientation=squarish",
    followedAt: "2025-05-18",
    isLive: true,
    listeners: 6340,
  },
  {
    id: 12,
    stationId: 8,
    stationName: "Radio Internacional Voz",
    frequency: "140.00 RFW",
    category: "Internacional",
    logoUrl: "https://readdy.ai/api/search-image?query=International%20radio%20station%20logo%20with%20globe%20and%20sound%20waves%2C%20circular%20minimalist%20design%2C%20blue%20and%20teal%20color%20palette%2C%20global%20broadcast%20emblem%2C%20multicultural%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-8&orientation=squarish",
    followedAt: "2025-06-02",
    isLive: false,
    listeners: 4523,
  },
];

export const listeningHistory: ListeningHistoryEntry[] = [
  {
    id: 1,
    stationId: 3,
    stationName: "La Mexicana FM",
    frequency: "103.50 RFW",
    category: "Regional Mexicana",
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-3&orientation=squarish",
    listenedAt: "2026-06-08T09:30:00",
    durationMinutes: 45,
    programName: "El Sabor del Mediodía",
  },
  {
    id: 2,
    stationId: 5,
    stationName: "Rock Total Radio",
    frequency: "87.01 RFW",
    category: "Rock",
    logoUrl: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-5&orientation=squarish",
    listenedAt: "2026-06-07T16:45:00",
    durationMinutes: 120,
    programName: "Rock Total en Vivo",
  },
  {
    id: 3,
    stationId: 7,
    stationName: "Deportes Total Radio",
    frequency: "120.00 RFW",
    category: "Deportes",
    logoUrl: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-7&orientation=squarish",
    listenedAt: "2026-06-07T12:00:00",
    durationMinutes: 90,
    programName: "La Mesa Redonda",
  },
  {
    id: 4,
    stationId: 1,
    stationName: "Radio Nueva Actitud",
    frequency: "94.70 RFW",
    category: "Pop",
    logoUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20and%20white%20color%20palette%2C%20simple%20geometric%20shapes%2C%20professional%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20high%20contrast%20vector%20style&width=200&height=200&seq=logo-1&orientation=squarish",
    listenedAt: "2026-06-06T19:00:00",
    durationMinutes: 180,
    programName: "Noche de Estrenos",
  },
  {
    id: 5,
    stationId: 2,
    stationName: "Radio Fe y Esperanza",
    frequency: "87.00 RFW",
    category: "Cristiana",
    logoUrl: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem%2C%20spiritual%20community%20radio%2C%20isolated%20on%20transparent%20background%2C%20vector%20style%20flat%20design&width=200&height=200&seq=logo-2&orientation=squarish",
    listenedAt: "2026-06-06T08:00:00",
    durationMinutes: 60,
    programName: "Mañana de Alabanza",
  },
  {
    id: 6,
    stationId: 12,
    stationName: "Banda Radio MX",
    frequency: "200.00 RFW",
    category: "Regional Mexicana",
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20and%20green%20colors%2C%20festive%20broadcast%20emblem%2C%20traditional%20Mexican%20vibe%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-12&orientation=squarish",
    listenedAt: "2026-06-05T15:00:00",
    durationMinutes: 150,
    programName: "Tardes de Banda",
  },
  {
    id: 7,
    stationId: 3,
    stationName: "La Mexicana FM",
    frequency: "103.50 RFW",
    category: "Regional Mexicana",
    logoUrl: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-3&orientation=squarish",
    listenedAt: "2026-06-04T20:00:00",
    durationMinutes: 120,
    programName: "Noche Norteña",
  },
  {
    id: 8,
    stationId: 9,
    stationName: "La Kalle 99.9",
    frequency: "99.90 RFW",
    category: "Pop",
    logoUrl: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20purple%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-9&orientation=squarish",
    listenedAt: "2026-06-04T10:00:00",
    durationMinutes: 75,
    programName: "Top 40 Matutino",
  },
  {
    id: 9,
    stationId: 5,
    stationName: "Rock Total Radio",
    frequency: "87.01 RFW",
    category: "Rock",
    logoUrl: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-5&orientation=squarish",
    listenedAt: "2026-06-03T21:00:00",
    durationMinutes: 90,
    programName: "Noche de Metal",
  },
  {
    id: 10,
    stationId: 4,
    stationName: "Noticias 24/7 Radio",
    frequency: "107.90 RFW",
    category: "Noticias",
    logoUrl: "https://readdy.ai/api/search-image?query=News%20radio%20station%20logo%20design%20with%20microphone%20and%20globe%20icon%2C%20circular%20minimalist%20emblem%2C%20blue%20and%20white%20professional%20color%20scheme%2C%20broadcast%20journalism%20style%2C%20isolated%20on%20transparent%20background%2C%20clean%20vector%20design&width=200&height=200&seq=logo-4&orientation=squarish",
    listenedAt: "2026-06-03T07:30:00",
    durationMinutes: 30,
    programName: "Resumen Matutino",
  },
];

export const sentMessages: SentMessageEntry[] = [
  {
    id: 1,
    stationId: 3,
    stationName: "La Mexicana FM",
    stationLogo: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-3&orientation=squarish",
    message: "Quiero mandar saludos a mi familia en Houston, los escucho todos los días desde la obra. ¡Arriba La Mexicana!",
    sentAt: "2026-06-08T10:15:00",
    type: "Saludo",
    status: "Leído al aire",
    reply: "¡Saludos a toda tu familia, Marco! Gracias por acompañarnos desde la obra. ¡Arriba Houston!",
  },
  {
    id: 2,
    stationId: 5,
    stationName: "Rock Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-5&orientation=squarish",
    message: "¿Pueden poner algo de Metallica? ¡Enter Sandman sería épico para esta tarde!",
    sentAt: "2026-06-07T17:30:00",
    type: "Solicitud de canción",
    status: "Leído al aire",
    reply: null,
  },
  {
    id: 3,
    stationId: 7,
    stationName: "Deportes Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-7&orientation=squarish",
    message: "¿Quién creen que gane el clásico este domingo? Yo digo que va 2-1.",
    sentAt: "2026-06-07T12:45:00",
    type: "Petición",
    status: "Pendiente",
    reply: null,
  },
  {
    id: 4,
    stationId: 1,
    stationName: "Radio Nueva Actitud",
    stationLogo: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20and%20white%20color%20palette%2C%20simple%20geometric%20shapes%2C%20professional%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20high%20contrast%20vector%20style&width=200&height=200&seq=logo-1&orientation=squarish",
    message: "Me encantó la entrevista con el artista de ayer, ¡qué talento! Voten por él en el concurso.",
    sentAt: "2026-06-06T20:30:00",
    type: "Concurso",
    status: "Archivado",
    reply: null,
  },
  {
    id: 5,
    stationId: 2,
    stationName: "Radio Fe y Esperanza",
    stationLogo: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem%2C%20spiritual%20community%20radio%2C%20isolated%20on%20transparent%20background%2C%20vector%20style%20flat%20design&width=200&height=200&seq=logo-2&orientation=squarish",
    message: "Pastor Daniel, sus palabras de hoy me llegaron al corazón. Gracias por su ministerio. Dios los bendiga.",
    sentAt: "2026-06-06T08:45:00",
    type: "Saludo",
    status: "Leído al aire",
    reply: "Amén, Marco. Dios te bendiga abundantemente. Gracias por compartir tu corazón con nosotros.",
  },
  {
    id: 6,
    stationId: 3,
    stationName: "La Mexicana FM",
    stationLogo: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-3&orientation=squarish",
    message: "Dediquen 'El Rey' a mi papá que hoy cumple años, por favor. Se llama Don José.",
    sentAt: "2026-06-05T14:00:00",
    type: "Petición",
    status: "Favorito",
    reply: "¡Claro que sí! Felicidades a Don José. Va 'El Rey' con todo el cariño.",
  },
  {
    id: 7,
    stationId: 9,
    stationName: "La Kalle 99.9",
    stationLogo: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20purple%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-9&orientation=squarish",
    message: "Están poniendo puro éxito hoy, ¡qué buena vibra! Saludos desde Phoenix.",
    sentAt: "2026-06-04T11:20:00",
    type: "Saludo",
    status: "Leído al aire",
    reply: null,
  },
];

export const savedEvents: SavedEventEntry[] = [
  {
    id: 1,
    stationId: 3,
    stationName: "La Mexicana FM",
    eventTitle: "Fiesta de Aniversario - 13 Años",
    eventDate: "2026-06-28",
    eventTime: "18:00",
    eventType: "Especial",
    imageUrl: "https://readdy.ai/api/search-image?query=Mexican%20festival%20celebration%20event%20with%20colorful%20decorations%2C%20music%20stage%20with%20lights%2C%20festive%20crowd%20atmosphere%2C%20warm%20vibrant%20colors%2C%20lively%20party%20scene%2C%20cultural%20celebration%20photography%20with%20bokeh%20lights%20and%20confetti&width=600&height=400&seq=event-saved-1&orientation=landscape",
    savedAt: "2026-06-05",
    isUpcoming: true,
  },
  {
    id: 2,
    stationId: 5,
    stationName: "Rock Total Radio",
    eventTitle: "Concierto en Vivo: Bandas Emergentes LA",
    eventDate: "2026-07-15",
    eventTime: "20:00",
    eventType: "Concierto",
    imageUrl: "https://readdy.ai/api/search-image?query=Live%20rock%20concert%20stage%20with%20electric%20guitars%20stage%20lighting%20and%20energetic%20crowd%2C%20concert%20venue%20atmosphere%20with%20fog%20machines%20and%20colorful%20lights%2C%20dynamic%20music%20photography%20with%20dramatic%20shadows&width=600&height=400&seq=event-saved-2&orientation=landscape",
    savedAt: "2026-05-20",
    isUpcoming: true,
  },
  {
    id: 3,
    stationId: 7,
    stationName: "Deportes Total Radio",
    eventTitle: "Cobertura Especial: Final de Campeones",
    eventDate: "2026-06-20",
    eventTime: "15:00",
    eventType: "Deportivo",
    imageUrl: "https://readdy.ai/api/search-image?query=Packed%20soccer%20stadium%20final%20match%20atmosphere%20with%20cheering%20fans%20and%20dramatic%20sky%2C%20stadium%20floodlights%2C%20passionate%20crowd%20scene%2C%20sports%20event%20photography%20with%20wide%20angle%20view&width=600&height=400&seq=event-saved-3&orientation=landscape",
    savedAt: "2026-06-01",
    isUpcoming: true,
  },
  {
    id: 4,
    stationId: 1,
    stationName: "Radio Nueva Actitud",
    eventTitle: "Summer Fest 2026 en Vivo",
    eventDate: "2026-08-10",
    eventTime: "16:00",
    eventType: "Festival",
    imageUrl: "https://readdy.ai/api/search-image?query=Summer%20music%20festival%20outdoor%20stage%20with%20vibrant%20decorations%20and%20dancing%20crowd%2C%20golden%20hour%20sunset%20lighting%2C%20colorful%20festival%20atmosphere%20with%20palm%20trees%2C%20joyful%20celebration%20scene%2C%20wide%20angle%20event%20photography&width=600&height=400&seq=event-saved-4&orientation=landscape",
    savedAt: "2026-05-15",
    isUpcoming: true,
  },
  {
    id: 5,
    stationId: 2,
    stationName: "Radio Fe y Esperanza",
    eventTitle: "Noche de Oración y Alabanza",
    eventDate: "2026-05-20",
    eventTime: "19:00",
    eventType: "Especial",
    imageUrl: "https://readdy.ai/api/search-image?query=Evening%20worship%20prayer%20gathering%20with%20warm%20candlelight%20atmosphere%2C%20peaceful%20spiritual%20community%20scene%2C%20soft%20warm%20lighting%2C%20serene%20church%20interior%20with%20stained%20glass%2C%20inspirational%20faith%20photography&width=600&height=400&seq=event-saved-5&orientation=landscape",
    savedAt: "2026-05-10",
    isUpcoming: false,
  },
];

export const notificationsList: NotificationEntry[] = [
  {
    id: 1,
    type: "new_transmission",
    title: "¡La Mexicana FM está transmitiendo!",
    message: "Alejandro Ramírez acaba de iniciar 'El Sabor del Mediodía'. Dale play y acompañalo en vivo.",
    timestamp: "2026-06-08T10:00:00",
    isRead: false,
    isArchived: false,
    actionUrl: "/radio/la-mexicana-fm",
    stationName: "La Mexicana FM",
  },
  {
    id: 2,
    type: "radio_message",
    title: "Tu mensaje fue leído al aire",
    message: "La Mexicana FM respondió tu saludo: '¡Saludos a toda tu familia, Marco! Gracias por acompañarnos desde la obra. ¡Arriba Houston!'",
    timestamp: "2026-06-08T10:20:00",
    isRead: false,
    isArchived: false,
    actionUrl: "/listener",
    stationName: "La Mexicana FM",
  },
  {
    id: 3,
    type: "new_event",
    title: "Fiesta de Aniversario - 13 Años",
    message: "La Mexicana FM celebra 13 años al aire este 28 de junio a las 6 PM. ¡Apartá la fecha!",
    timestamp: "2026-06-07T18:00:00",
    isRead: true,
    isArchived: false,
    actionUrl: "/radio/la-mexicana-fm",
    stationName: "La Mexicana FM",
  },
  {
    id: 4,
    type: "upcoming_live",
    title: "Live próximo: Indie Sessions",
    message: "Rock Total Radio estrena 'Indie Sessions' este sábado a las 8 PM. Invitado sorpresa de la escena under.",
    timestamp: "2026-06-07T14:30:00",
    isRead: true,
    isArchived: false,
    actionUrl: "/radio/rock-total-radio",
    stationName: "Rock Total Radio",
  },
  {
    id: 5,
    type: "new_transmission",
    title: "Deportes Total Radio al aire",
    message: "Arrancó La Mesa Redonda con análisis completo de la jornada futbolera. ¡No te la pierdas!",
    timestamp: "2026-06-07T12:00:00",
    isRead: true,
    isArchived: false,
    actionUrl: "/radio/deportes-total-radio",
    stationName: "Deportes Total Radio",
  },
  {
    id: 6,
    type: "contest",
    title: "¡Ganaste el concurso semanal!",
    message: "Felicitaciones Marco, tu mensaje fue seleccionado como el mejor de la semana en Radio Nueva Actitud. Reclamá tu premio.",
    timestamp: "2026-06-06T20:00:00",
    isRead: true,
    isArchived: true,
    actionUrl: "/listener",
    stationName: "Radio Nueva Actitud",
  },
  {
    id: 7,
    type: "new_event",
    title: "Cobertura Especial: Final de Campeones",
    message: "Deportes Total Radio transmitirá en vivo la gran final este 20 de junio desde las 3 PM. Cobertura total.",
    timestamp: "2026-06-05T09:00:00",
    isRead: true,
    isArchived: false,
    actionUrl: "/radio/deportes-total-radio",
    stationName: "Deportes Total Radio",
  },
  {
    id: 8,
    type: "contest",
    title: "Concurso: Entrevista exclusiva",
    message: "Radio Nueva Actitud sortea un meet & greet con el artista invitado de esta semana. Participá enviando tu pregunta.",
    timestamp: "2026-06-04T16:00:00",
    isRead: true,
    isArchived: false,
    actionUrl: "/radio/radio-nueva-actitud",
    stationName: "Radio Nueva Actitud",
  },
  {
    id: 9,
    type: "upcoming_live",
    title: "Tardes de Banda en Vivo",
    message: "Banda Radio MX anunció live especial este 15 de junio con El Compa Luis. Habrá dedicatorias en vivo.",
    timestamp: "2026-06-03T08:00:00",
    isRead: true,
    isArchived: true,
    actionUrl: "/radio/banda-radio-mx",
    stationName: "Banda Radio MX",
  },
  {
    id: 10,
    type: "radio_message",
    title: "Radio Fe y Esperanza te respondió",
    message: "El Pastor Daniel leyó tu mensaje al aire: 'Amén, Marco. Dios te bendiga abundantemente. Gracias por compartir.'",
    timestamp: "2026-06-06T09:00:00",
    isRead: false,
    isArchived: false,
    actionUrl: "/listener",
    stationName: "Radio Fe y Esperanza",
  },
  {
    id: 11,
    type: "new_transmission",
    title: "Banda Radio MX está al aire",
    message: "Acaba de empezar la transmisión en vivo con lo mejor de la banda. ¡Pura música de la buena!",
    timestamp: "2026-06-02T11:00:00",
    isRead: true,
    isArchived: true,
    actionUrl: "/radio/banda-radio-mx",
    stationName: "Banda Radio MX",
  },
  {
    id: 12,
    type: "radio_message",
    title: "Tu solicitud fue leída al aire",
    message: "La Kalle 99.9 puso el tema que pediste. Majo Hernández te mandó saludos por la dedicatoria.",
    timestamp: "2026-06-01T15:30:00",
    isRead: true,
    isArchived: false,
    actionUrl: "/radio/la-kalle-99-9",
    stationName: "La Kalle 99.9",
  },
];

export const savedLives: SavedLiveEntry[] = [
  {
    id: 1,
    stationId: 3,
    stationName: "La Mexicana FM",
    stationLogo: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20station%20logo%20with%20guitar%20and%20sombrero%20elements%2C%20circular%20design%20warm%20orange%20and%20green%20colors%2C%20clean%20modern%20broadcast%20style%2C%20festive%20vibrant%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-3&orientation=squarish",
    programName: "El Sabor del Mediodía",
    hostName: "Alejandro Ramírez",
    savedAt: "2026-06-08T09:00:00",
    status: "live",
    durationMinutes: 120,
    coverUrl: "https://readdy.ai/api/search-image?query=Mexican%20regional%20radio%20live%20broadcast%20studio%20with%20host%20speaking%20into%20vintage%20microphone%2C%20warm%20ambient%20lighting%20with%20orange%20glow%2C%20audio%20mixing%20console%20in%20foreground%2C%20radio%20station%20booth%20atmosphere%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field&width=600&height=400&seq=live-saved-1&orientation=landscape",
  },
  {
    id: 2,
    stationId: 5,
    stationName: "Rock Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Rock%20radio%20station%20logo%20with%20electric%20guitar%20and%20lightning%20bolt%2C%20circular%20design%20black%20and%20red%20color%20scheme%2C%20modern%20rock%20broadcast%20emblem%2C%20energetic%20and%20bold%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-5&orientation=squarish",
    programName: "Noche de Metal Extremo",
    hostName: "Diego \"El Lobo\" Vargas",
    savedAt: "2026-06-07T21:00:00",
    status: "finished",
    durationMinutes: 90,
    coverUrl: "https://readdy.ai/api/search-image?query=Heavy%20metal%20radio%20show%20studio%20with%20dark%20atmospheric%20lighting%20red%20and%20purple%20neon%20glow%2C%20skull%20decorations%20on%20desk%2C%20host%20with%20long%20hair%20speaking%20into%20microphone%2C%20intense%20dramatic%20broadcast%20scene%2C%20editorial%20concert%20photography%20vibe&width=600&height=400&seq=live-saved-2&orientation=landscape",
  },
  {
    id: 3,
    stationId: 7,
    stationName: "Deportes Total Radio",
    stationLogo: "https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20with%20soccer%20ball%20and%20trophy%20icon%2C%20circular%20design%20dark%20blue%20and%20gold%20color%20scheme%2C%20dynamic%20broadcast%20emblem%2C%20energetic%20sports%20feel%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-7&orientation=squarish",
    programName: "Domingo Futbolero en Vivo",
    hostName: "Carlos Márquez",
    savedAt: "2026-06-20T10:00:00",
    status: "scheduled",
    durationMinutes: 180,
    coverUrl: "https://readdy.ai/api/search-image?query=Sports%20radio%20live%20broadcast%20studio%20setup%20with%20soccer%20memorabilia%20on%20walls%2C%20multiple%20screens%20showing%20match%20highlights%2C%20energetic%20host%20with%20headset%20speaking%2C%20green%20screen%20background%20with%20stadium%20visuals%2C%20dynamic%20sports%20media%20atmosphere&width=600&height=400&seq=live-saved-3&orientation=landscape",
  },
  {
    id: 4,
    stationId: 1,
    stationName: "Radio Nueva Actitud",
    stationLogo: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20radio%20station%20logo%20design%20with%20musical%20notes%20and%20frequency%20waves%2C%20clean%20circular%20emblem%20style%2C%20warm%20golden%20and%20white%20color%20palette%2C%20simple%20geometric%20shapes%2C%20professional%20broadcast%20aesthetic%2C%20isolated%20on%20transparent%20background%2C%20high%20contrast%20vector%20style&width=200&height=200&seq=logo-1&orientation=squarish",
    programName: "Noche de Estrenos Pop",
    hostName: "Valentina Suárez",
    savedAt: "2026-06-18T19:00:00",
    status: "scheduled",
    durationMinutes: 120,
    coverUrl: "https://readdy.ai/api/search-image?query=Modern%20pop%20radio%20studio%20with%20neon%20pink%20and%20blue%20ambient%20lighting%2C%20female%20host%20with%20headphones%20smiling%2C%20vinyl%20records%20displayed%20on%20wall%2C%20sleek%20contemporary%20broadcast%20booth%20design%2C%20trendy%20youthful%20media%20production%20photography&width=600&height=400&seq=live-saved-4&orientation=landscape",
  },
  {
    id: 5,
    stationId: 2,
    stationName: "Radio Fe y Esperanza",
    stationLogo: "https://readdy.ai/api/search-image?query=Christian%20radio%20station%20logo%20with%20dove%20symbol%2C%20circular%20minimalist%20design%2C%20soft%20warm%20colors%20white%20and%20gentle%20golden%20tones%2C%20clean%20modern%20broadcast%20emblem%2C%20spiritual%20community%20radio%2C%20isolated%20on%20transparent%20background%2C%20vector%20style%20flat%20design&width=200&height=200&seq=logo-2&orientation=squarish",
    programName: "Mañana de Alabanza en Vivo",
    hostName: "Pastor Daniel Ortega",
    savedAt: "2026-06-06T08:00:00",
    status: "finished",
    durationMinutes: 60,
    coverUrl: "https://readdy.ai/api/search-image?query=Warm%20peaceful%20radio%20studio%20with%20soft%20golden%20morning%20light%20streaming%20through%20window%2C%20pastor%20speaking%20gently%20into%20microphone%2C%20acoustic%20guitar%20in%20background%2C%20serene%20spiritual%20atmosphere%2C%20inspirational%20broadcast%20photography%20with%20warm%20tones&width=600&height=400&seq=live-saved-5&orientation=landscape",
  },
  {
    id: 6,
    stationId: 12,
    stationName: "Banda Radio MX",
    stationLogo: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20station%20logo%20with%20trumpet%20and%20accordion%2C%20circular%20design%20red%20white%20and%20green%20colors%2C%20festive%20broadcast%20emblem%2C%20traditional%20Mexican%20vibe%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-12&orientation=squarish",
    programName: "Tardes de Banda en Vivo",
    hostName: "El Compa Luis",
    savedAt: "2026-06-15T15:00:00",
    status: "scheduled",
    durationMinutes: 150,
    coverUrl: "https://readdy.ai/api/search-image?query=Mexican%20banda%20music%20radio%20studio%20with%20festive%20colorful%20decorations%20papel%20picado%20banners%2C%20host%20with%20cowboy%20hat%20speaking%20into%20microphone%2C%20instruments%20in%20background%20including%20trumpet%20and%20accordion%2C%20lively%20traditional%20Mexican%20broadcast%20atmosphere&width=600&height=400&seq=live-saved-6&orientation=landscape",
  },
  {
    id: 7,
    stationId: 9,
    stationName: "La Kalle 99.9",
    stationLogo: "https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20logo%20with%20headphones%20and%20music%20equalizer%20bars%2C%20circular%20design%20vibrant%20pink%20and%20purple%20colors%2C%20modern%20youthful%20broadcast%20emblem%2C%20energetic%20style%2C%20isolated%20on%20transparent%20background%2C%20vector%20flat%20design&width=200&height=200&seq=logo-9&orientation=squarish",
    programName: "Top 40 Matutino Live",
    hostName: "Majo Hernández",
    savedAt: "2026-06-04T10:00:00",
    status: "finished",
    durationMinutes: 75,
    coverUrl: "https://readdy.ai/api/search-image?query=Energetic%20pop%20music%20radio%20morning%20show%20studio%20with%20colorful%20LED%20panel%20lights%2C%20young%20female%20host%20laughing%20into%20microphone%2C%20coffee%20cup%20on%20desk%2C%20bright%20cheerful%20atmosphere%2C%20modern%20youthful%20broadcast%20production%20photography&width=600&height=400&seq=live-saved-7&orientation=landscape",
  },
];